import Devices from "../Devices/Devices"

const NonCompliantDevices = () => (
  <Devices
    preset={{ compliance: "Non-Compliant" }}
    locked={["compliance"]}
    title="Non-compliant devices"
  />
)

export default NonCompliantDevices
